var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.2px",
    height: "18.2px",
    viewBox: "0 0 1024 1024",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.286 841.143h219.429v-109.714h-219.429v109.714zM0 182.857v109.714h1024v-109.714h-1024zM182.857 568.686h658.286v-113.371h-658.286v113.371z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripes);
export default __webpack_public_path__ + "static/media/stripes.4586f13a54a640159993abe03f18b23e.svg";
export { ForwardRef as ReactComponent };